module.exports = __webpack_public_path__ + "static/media/baby-carriage.c28a7377.svg";